module.exports = __webpack_public_path__ + "static/media/page1.7e94ffc8.png";